import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AssetDto, Tag } from '@nusign/picflow-backend-types';
import { tap } from 'rxjs';
import { AppConfigService } from '../providers/config.service';
import { AssetService } from './asset.service';

@Injectable({
  providedIn: 'root',
})
export class AssetTagService {
  private http = inject(HttpClient);
  private config = inject(AppConfigService);
  private assetService = inject(AssetService);

  public add(asset: AssetDto, tag: Tag) {
    return this.http.put<void>(`${this.config.apiEndpoint}/assets/${asset.id}/tags/${tag.id}`, {}).pipe(
      tap(() => {
        this.assetService.optimisticUpdateAsset(asset, { tags: [...asset.tags, tag] });
      })
    );
  }

  public remove(asset: AssetDto, tag: Tag) {
    return this.http.delete(`${this.config.apiEndpoint}/assets/${asset.id}/tags/${tag.id}`).pipe(
      tap(() => {
        this.assetService.optimisticUpdateAsset(asset, { tags: asset.tags.filter(t => t.id !== tag.id) });
      })
    );
  }
}
